<div class="flex-header mat-dialog-title">Reset Password</div>
<div class="flex-content">
  <form [formGroup]="resetPasswordForm" #formDir="ngForm" style="padding-bottom: 15px;">
    <div *ngIf="!isLinkExpired" [class.cross-validation-error]="resetPasswordForm.errors?.passwordsMustMatch && (resetPasswordForm.touched && resetPasswordForm.dirty && repeatNewPassword.touched)">
      <div class="">
        <tyl-form-field label="New Password" [errorMessage]="newPasswordError" style="width: 100%">
          <input matInput aria-label="New Password" id="txtNewPassword" type="password"
                 formControlName="newPassword" required>
        </tyl-form-field>
      </div>
      <div class="">
        <tyl-form-field label="Re-enter Password" [errorMessage]="repeatNewPasswordError" style="width: 100%">
          <input matInput aria-label="Re-enter Password" id="txtRepeatNewPassword"
                 type="password" formControlName="repeatNewPassword" required>
        </tyl-form-field>
      </div>
      <div
        *ngIf="resetPasswordForm.errors?.passwordsMustMatch && (repeatNewPassword.dirty && repeatNewPassword.touched)"
        class="formAlertMessage" translate>
        Passwords do not match
      </div>
    </div>
    <div *ngIf="isLinkExpired == true">
        {{resetPasswordMessage}}
    </div>
  </form>
</div>
<div class="flex-footer">
  <div class="flex-footer-right">
    <tyl-button image="save.png" label="Save" (clickEvent)="saveClick()" translate *ngIf="isLinkExpired == false"></tyl-button>
    <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="closeClick()" translate *ngIf="isLinkExpired == false"></tyl-button>
    <tyl-button image="save.png" label="Ok" (clickEvent)="closeClick()" translate *ngIf="isLinkExpired == true"></tyl-button>
  </div>
</div>






